var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburguerAurea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.03846C0 0.46494 0.6396 0 1.42857 0H18.5714C19.3604 0 20 0.46494 20 1.03846C20 1.61198 19.3604 2.07692 18.5714 2.07692H1.42857C0.6396 2.07692 0 1.61198 0 1.03846Z",
    fill: "#403E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.00001C0 8.42649 0.6396 7.96155 1.42857 7.96155H18.5714C19.3604 7.96155 20 8.42649 20 9.00001C20 9.57355 19.3604 10.0385 18.5714 10.0385H1.42857C0.6396 10.0385 0 9.57355 0 9.00001Z",
    fill: "#403E3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.9616C0 16.388 0.6396 15.9231 1.42857 15.9231H10C10.789 15.9231 11.4286 16.388 11.4286 16.9616C11.4286 17.5351 10.789 18 10 18H1.42857C0.6396 18 0 17.5351 0 16.9616Z",
    fill: "#403E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburguerAurea);
export default __webpack_public_path__ + "static/media/hamburguer-aurea.3745df7bdd23e87f4fa602dde5b42ac5.svg";
export { ForwardRef as ReactComponent };